import { type FC, type PropsWithChildren } from 'react';
import { type SocureDocVSDKConfig, type SocureWebSDKLaunchResult } from './SocureWebSDK';

export type FCC<P = Record<string, never>> = FC<PropsWithChildren<P>>;

export type VariablesType = Record<string, boolean | number | Date | string | null>;

export enum SessionStorageField {
  Page = 'page',
  ApplicationDisplayId = 'applicationDisplayId',
  OTPAttempts = 'attempts',
  AppState = 'sparrowCard',
}

/* eslint-disable @typescript-eslint/naming-convention */
//can be disabled here since those properties are set by 3rd party scripts
declare global {
  interface Window {
    io_global_object_name: string;
    gtag: (...args: unknown[]) => void;
    SocureDocVSDK: {
      launch: (
        socureSdkKey: string,
        docvTransactionToken: string,
        elemendId: string,
        config?: SocureDocVSDKConfig,
      ) => Promise<SocureWebSDKLaunchResult>;
      reset: () => void;
    };
  }
}

export interface OutletContextType {
  applicationId: string;
  submissionId: string;
}
